<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="gridName" label="网格名称">
              <el-input clearable v-model="formData.gridName" placeholder="请输入网格名称" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="areaId" label="区域">
              <el-select v-model="formData.areaId" placeholder="请选择区域">
                <el-option v-for="item in areaList" :label="item.areaName" :value="item.areaId" :key="item.areaId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任部门" prop="deptId">
              <el-cascader ref="cascader" v-model="formData.deptId" :show-all-levels="false" :options="deptList"
                :props="{ emitPath: false, label: 'deptName', value: 'deptId', children: 'childNode', checkStrictly: true }">
              </el-cascader>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'GridMangeAdd',
  data() {
    return {
      areaList: [],
      deptList: [],
      formData: {
        areaId: '', // 区域id
        gridName: '', // 网格名称
        deptId: '' // 责任部门id
      },
      rules: {
        gridName: [
          { required: true, message: '请输入网格名称' }
        ],
        areaId: [
          { required: true, message: '请选择区域' }
        ],
        deptId: [
          { required: true, message: '请选择责任部门' }
        ]
      }
    }
  },
  created() {
    if (this.gridId) {
      this.loadData()
    }
    this.loadAreaList()
    this.loadDeptList()
  },
  computed: {
    gridId() {
      return this.$route.query.gridId
    }
  },
  methods: {
    loadAreaList() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByPage).then(res => {
        this.areaList = res.list
      })
    },
    loadDeptList() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.deptList = res
      })
    },
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryGridByGridId, { gridId: this.gridId }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.wspb.insertPaFactoryGrid
        if (this.gridId) {
          url = this.$apis.wspb.updatePaFactoryGrid
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
